import React from "react";

const ExamTimerFloat = ({ countdownFormatted }) => {
  if (countdownFormatted == null) return null;

  return (
    <div className="exam-timer-float">
      <i className="fas fa-clock font-color-red font_20 me-2" />
      <div>
        <p className="font_16 font-color-grey mb-0">الوقت المتبقي</p>
        <p className="font_20 mb-0 font-extrabold font-color-red">
          {countdownFormatted}
        </p>
      </div>
    </div>
  );
};

export default ExamTimerFloat;
